import { useCallback } from 'react';

import { EditorView } from '@lyearn/lygo-core';

import { getMarkType, toggleMark } from '../SelectionMenu/commands';
import { adaptHref } from '../SelectionMenu/utils';
import { hideLinkMarkMenu } from './utils';

export const useOnLinkSave = (view: EditorView, href: string) => {
  return useCallback(() => {
    if (view) {
      const markType = getMarkType('link', view.state.schema);
      if (!markType) return;

      toggleMark(markType, { href: adaptHref(href) }, true)(view.state, view.dispatch);
      hideLinkMarkMenu(view.state, view.dispatch);
    }
  }, [view, href]);
};

export const useOnLinkDelete = (view: EditorView) => {
  return useCallback(() => {
    if (view) {
      const markType = getMarkType('link', view.state.schema);
      if (!markType) return;

      toggleMark(markType)(view.state, view.dispatch);
      hideLinkMarkMenu(view.state, view.dispatch);
    }
  }, [view]);
};
